// Component
import FormSlip from "./FormSlip";

const DepositFormSlipApp = ({ depositItems }) => {

    return (
        <FormSlip depositItems={depositItems} />
    );
}

export default DepositFormSlipApp;